import { render, staticRenderFns } from "./QrCode.vue?vue&type=template&id=474442e1&"
import script from "./QrCode.vue?vue&type=script&lang=ts&"
export * from "./QrCode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('474442e1')) {
      api.createRecord('474442e1', component.options)
    } else {
      api.reload('474442e1', component.options)
    }
    module.hot.accept("./QrCode.vue?vue&type=template&id=474442e1&", function () {
      api.rerender('474442e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/custom/qrcode/QrCode.vue"
export default component.exports